import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';
import Form from 'erpcore/components/Form';
import Button from 'erpcore/components/Button';
import Svg from 'erpcore/components/Svg';
import Tooltip from 'erpcore/components/Tooltip';
import Modal from 'erpcore/components/Modal';
import { actions as activityActions } from 'erpcore/screens/Activities/Activities.reducer';

const ActivitiesDelete = ({ id, handleSubmit, submitting, callback }) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const activityIri = `api/activities/${id}`;

    const handleModal = () => {
        setOpened(!opened);
    };

    const onSubmit = () => {
        return new Promise((resolve, reject) =>
            dispatch({
                promise: { resolve, reject },
                type: activityActions.START_DELETE_ACTIVITY,
                iri: activityIri
            })
        )
            .then(() => {
                handleModal();
                callback();
            })
            .catch(error => {
                handleModal();
                return error;
            });
    };

    return (
        <Fragment>
            <Tooltip content="Delete template">
                <button type="button" onClick={() => handleModal()}>
                    <Svg icon="remove" />
                </button>
            </Tooltip>
            <Modal
                variation="small"
                opened={opened}
                onClose={() => handleModal()}
                title="Delete template"
                subtitle="Are you sure you want to delete this template?"
            >
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Button submit loading={submitting} label="Delete" />
                    <Button variation="secondary" label="Cancel" onClick={() => handleModal()} />
                </Form>
            </Modal>
        </Fragment>
    );
};

ActivitiesDelete.defaultProps = {
    submitting: false,
    id: null,
    callback: () => {}
};

ActivitiesDelete.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    callback: PropTypes.func
};

export default reduxForm({
    form: 'ActivitiesDeleteForm',
    enableReinitialize: true
})(ActivitiesDelete);
